import React, { JSX, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import theme from './theme/theme';
import Router from './routes';
import ScrollToTop from './components/ScrollToTop';
import { ContextProvider } from './context';
import { AuthProvider, useAuth } from './context/auth/AuthContext';
import { supabase } from './services/supabase/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoadingScreen } from './components';
import NavigationDebugger from './components/NavigationDebugger';

import 'react-toastify/dist/ReactToastify.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// AuthGuard component to handle global loading state
import { TransactionDrawerProvider } from './context/transaction/TransactionDrawerContext';

function AuthGuardedApp(): JSX.Element {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen message="Initializing application..." />;
  }

  return (
    <ContextProvider>
      {/* <NavigationDebugger /> */}
      <TransactionDrawerProvider>
        <ScrollToTop />
        <Router />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </TransactionDrawerProvider>
    </ContextProvider>
  );
}

export function App(): JSX.Element {
  const supabaseTest = async () => {
    const { data, error } = await supabase.from('users').select();
  };

  useEffect(() => {
    supabaseTest();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <AuthGuardedApp />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
